module.exports = __webpack_public_path__ + "img/share-fb-icon.3380b41c.svg";